<template>
<v-autocomplete ref="focus" :loading="loading" :value="value" :items="items" item-text="title" item-value="_id" label="گروه" :rules="requiredRules" @input="v => $emit('input', v)" dense no-data-text="اطلاعاتی موجود نیست...">
</v-autocomplete>
</template>

<script>
//
import myAxios from '../../functions/myAxios'

export default {
  name: 'MygPersons',
  props: {
    value: {
      // type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      items: [],
      requiredRules: [
        v => !!v || 'فیلد اجباری',
      ],
    }
  },
  methods: {
    async retrieveData() {
      //
      this.loading = true
      try {
        let res = await myAxios({
          method: 'GET',
          url: `/api/g_persons`,
        });
        // console.log(res.data);
        if (res && res.data) {
          let title = res.data.map(function(item) {
            return {
              _id: item._id,
              title: item.title
            }
          })
          this.items = title
          this.loading = false
        }
      } catch (e) {
        console.error(e)
      }
    },
  },
  async created() {
    await this.retrieveData()
  },
}
</script>
